import React, { useState } from 'react'
import './Header.css'
import { Link } from 'react-router-dom'

function Header() {
  const [childNav, setChildNav] = useState(false)
  const [sidebar, setSidebar] = useState(false)
  const [sideBarStyle, setSidebarStyle] = useState({
    left: '-250px',
  })

  const slideRight = () => {
    setSidebarStyle({
      left: '0',
    })
  }

  const slideLeft = () => {
    setSidebarStyle({
      left: '-250px',
    })
  }
  return (
    <header>
      <div className="header-area header-style-one">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 d-flex align-items-center justify-content-between py-3">
              <a href="https://vitiyagyanmela.icai.org" className='d-inline-block website-logo'>
                <img className="main-logo w-100" src="https://vitiyagyanmela.icai.org/frontend/assets/images/logo.jpg" alt="logo" />
              </a>
              <div className="d-flex w-100 justify-content-end align-items-center">
                {sidebar ? <i className="fa-solid fa-xmark me-3" style={{ fontSize: "24px", color: "#444", cursor: "pointer" }} onClick={() => { setSidebar(false); slideLeft()}}></i> : <i className="fa-solid fa-bars navbars-toogle me-3" style={{ fontSize: "24px", color: "#444", cursor: "pointer" }} onClick={() => { setSidebar(true); slideRight() }}></i>}
                  <div style={sideBarStyle} className="col-lg-11 align-items-center d-flex justify-content-end navbar-custom mobile-header">
                    <nav className="main-nav">
                      {/* <div className="inner-logo d-xl-none">
                        <a href="#" className="logoEvent">
                          <img src="https://vitiyagyanmela.icai.org/frontend/assets/images/logo.jpg" alt="logo" width="160px" style={{ marginTop: "0" }} />
                          <img src="https://vitiyagyanmela.icai.org/frontend/assets/images/logo-v2.png" alt/>
                        </a>
                      </div> */}
                      <ul id="navBar" className='ps-0'>
                        <li className="has-child-menu">
                          <a href="https://vitiyagyanmela.icai.org" className="active">Home </a>
                        </li>
                        <li>
                          <a href="https://vitiyagyan.icai.org/" target="_blank" className="">Vityagyan </a>
                        </li>
                        <li>
                          <a href="https://vitiyagyanmela.icai.org/about" className="">About </a>
                        </li>

                        <li className="has-child-menu">
                          <a href="https://vitiyagyanmela.icai.org/registration" className="">Registration</a>
                        </li>

                        <li className="has-child-menu">
                          <a href="https://vitiyagyanmela.icai.org/events" className="">Events</a>
                        </li>
                        <li className="has-child-menu">
                          <a href="https://vitiyagyanmela.icai.org/stalls" className="">Knowledge Booth</a>
                        </li>
                        <li className="has-child-menu">
                          <a href="https://vitiyagyanmela.icai.org/knowledge-hub" className="">Knowledge Hub</a>
                        </li>
                        <li className="has-child-menu">
                          <div className="dropdown outline-none" onClick={() => { setChildNav((prev) => !prev) }}>
                            <a className="btn dropdown-toggle my-dropdowm " href="#" role="button" id="dropdownMenuLink2" data-bs-toggle="dropdown" aria-expanded="false">
                              Media
                            </a>
                            {childNav && <ul className="custom-dropdown-menu my-dropdown-menu activities-dropdown" aria-labelledby="dropdownMenuLink2">
                              <li>
                                <a className="dropdown-item pe-5 " href="https://vitiyagyanmela.icai.org/media/gallary">Photos</a>
                              </li>
                              <li>
                                <a className="dropdown-item pe-5 " href="https://vitiyagyanmela.icai.org/media/video">Videos</a>
                              </li>
                            </ul>}
                          </div>
                        </li>
                        <li className="has-child-menu">
                          <a href="https://vitiyagyanmela.icai.org/feedback" className="">Feedback</a>
                        </li>
                        <li className="has-child-menu">
                          <a href="https://vitiyagyanmela.icai.org/contact" className="">Contact/Branch</a>
                        </li>
                      </ul>
                    </nav>
                  </div> 
                <div className="col-lg-11 align-items-center d-flex justify-content-end navbar-custom desktop-header">
                  <nav className="main-nav">
                    {/* <div className="inner-logo d-xl-none">
                        <a href="#" className="logoEvent">
                          <img src="https://vitiyagyanmela.icai.org/frontend/assets/images/logo.jpg" alt="logo" width="160px" style={{ marginTop: "0" }} />
                          <img src="https://vitiyagyanmela.icai.org/frontend/assets/images/logo-v2.png" alt/>
                        </a>
                      </div> */}
                    <ul id="navBar" className='ps-0'>
                      <li className="has-child-menu">
                        <a href="https://vitiyagyanmela.icai.org" className="active">Home </a>
                      </li>
                      <li>
                        <a href="https://vitiyagyan.icai.org/" target="_blank" className="">Vityagyan </a>
                      </li>
                      <li>
                        <a href="https://vitiyagyanmela.icai.org/about" className="">About </a>
                      </li>

                      <li className="has-child-menu">
                        <a href="https://vitiyagyanmela.icai.org/registration" className="">Registration</a>
                      </li>

                      <li className="has-child-menu">
                        <a href="https://vitiyagyanmela.icai.org/events" className="">Events</a>
                      </li>
                      <li className="has-child-menu">
                        <a href="https://vitiyagyanmela.icai.org/stalls" className="">Knowledge Booth</a>
                      </li>
                      <li className="has-child-menu">
                        <a href="https://vitiyagyanmela.icai.org/knowledge-hub" className="">Knowledge Hub</a>
                      </li>
                      <li className="has-child-menu">
                        <div className="dropdown outline-none" onClick={() => { setChildNav((prev) => !prev) }}>
                          <a className="btn dropdown-toggle my-dropdowm " href="#" role="button" id="dropdownMenuLink2" data-bs-toggle="dropdown" aria-expanded="false">
                            Media
                          </a>
                          {childNav && <ul className="custom-dropdown-menu my-dropdown-menu activities-dropdown" aria-labelledby="dropdownMenuLink2">
                            <li>
                              <a className="dropdown-item pe-5 " href="https://vitiyagyanmela.icai.org/media/gallary">Photos</a>
                            </li>
                            <li>
                              <a className="dropdown-item pe-5 " href="https://vitiyagyanmela.icai.org/media/video">Videos</a>
                            </li>
                          </ul>}
                        </div>
                      </li>
                      <li className="has-child-menu">
                        <a href="https://vitiyagyanmela.icai.org/feedback" className="">Feedback</a>
                      </li>
                      <li className="has-child-menu">
                        <a href="https://vitiyagyanmela.icai.org/contact" className="">Contact/Branch</a>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div className="col-lg-1">
                  <div className="nav-right h-100 d-flex align-items-center justify-content-end">
                    <ul className="d-flex justify-content-end mb-0 px-0">
                      <li className="nav-btn">
                        <Link to="/ambassador/login" className='login-btn-fill'>Login</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
